"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.del_jd_activity = del_jd_activity;
exports.get_jd_activity = get_jd_activity;
exports.save_jd_activity = save_jd_activity;
var _request = _interopRequireDefault(require("@/utils/request"));
// 管理端-查询京东爆品联盟配置
function get_jd_activity(params) {
  return (0, _request.default)({
    url: "/portal/system/union/jdActivity",
    method: "get",
    params: params
  });
}

// 管理端-保存京东爆品联盟配置
function save_jd_activity(data) {
  return (0, _request.default)({
    url: "/portal/system/union/jdActivitySave",
    method: "post",
    data: data
  });
}

// 管理端-删除京东爆品联盟配置
function del_jd_activity(data) {
  return (0, _request.default)({
    url: "/portal/system/union/jdActivityDel",
    method: "post",
    data: data
  });
}